"use client";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";
import React from "react";

const ShelvePromotion1Loader = ({ children, promotionData, variants }: { children?: React.ReactNode; promotionData: any; variants: any }) => {
    const { hasMouseMoved } = useMouseMovement();
    
    return hasMouseMoved ? (
        children
    ) : (
        <section>
            {promotionData.map((item: any, index: number) => (
                item.productVariant.filter((variant: any) => variants.includes(variant.id)).map((filteredVariant: any, index: number) => (
                    <React.Fragment key={index}>
                        <img alt={filteredVariant.id} /> <br />
                        {filteredVariant.msProductHandle} <br />
                        price {filteredVariant.priceFull}฿
                    </React.Fragment>
                ))  
            ))}
        </section>
    );
}

export default ShelvePromotion1Loader;